export const defaultSortOptions = [
    {
        text: 'A - Z',
        value: 'title',
        queryValue: 'title',
        dir: 'asc',
        isDefault: true
    },
    {
        text: 'Z - A',
        value: 'title',
        queryValue: 'title',
        dir: 'desc'
    },
    {
        text: '$ - $$$',
        value: 'price',
        queryValue: 'price',
        dir: 'asc'
    },
    {
        text: '$$$ - $',
        value: 'price',
        queryValue: 'price',
        dir: 'desc'
    },
    {
        text: 'Newest',
        value: 'date_added',
        queryValue: 'date',
        dir: 'asc'
    }
]



// WEBPACK FOOTER //
// ./src/utils/sorting.js